const initialState = 1;

const searchDetailsTorrensCertificatesPaginationReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SET_SELECTED_DETAILS_TORRENS_CERTIFICATES_PAGE':
                  return action.pageNumber;
            case 'LOGOUT_USER':
                        return 1;                  
            default:
                  break;
      }
      return state;
};
export default searchDetailsTorrensCertificatesPaginationReducer;